const colorGradient = {
  colorLeft: '#2f9db4',
  colorRight: '#76dbc7',
};
export default {
  colorGradient,
};
